/* Aqua di Polo — hero slider.
   Tek slaytta hiçbir şey yapmaz. Otomatik geçiş yalnızca panelden açıksa ve
   kullanıcı hareket azaltma istemiyorsa çalışır; sekme arka plandayken,
   fare üzerindeyken ve odak içerideyken durur. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.dataset.adpHeroBound) return;
    root.dataset.adpHeroBound = '1';

    var slides = root.querySelectorAll('[data-adp-hero-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-adp-hero-dot]');
    var pause = root.querySelector('[data-adp-hero-pause]');
    var secs = parseInt(root.getAttribute('data-adp-hero-autoplay') || '0', 10);
    var current = 0;
    var timer = null;
    var stopped = false;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === current ? 'true' : 'false'); });
    }

    function start() {
      if (!secs || reduced || stopped) return;
      clearInterval(timer);
      timer = setInterval(function () { go(current + 1); }, secs * 1000);
    }
    function halt() { clearInterval(timer); timer = null; }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-adp-hero-dot'), 10));
        halt(); start();
      });
    });

    if (pause) {
      pause.addEventListener('click', function () {
        stopped = !stopped;
        pause.setAttribute('aria-pressed', stopped ? 'true' : 'false');
        pause.setAttribute('aria-label', stopped ? 'Otomatik geçişi başlat' : 'Otomatik geçişi durdur');
        if (stopped) halt(); else start();
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(current + 1); halt(); start(); }
      else if (e.key === 'ArrowLeft') { go(current - 1); halt(); start(); }
      else return;
      e.preventDefault();
    });

    // kullanıcı içerideyken kaydırma
    root.addEventListener('mouseenter', halt);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', halt);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) halt(); else start();
    });

    // dokunmatik kaydırma
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; halt(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(current + (dx < 0 ? 1 : -1));
      x0 = null; start();
    }, { passive: true });

    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-adp-hero]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
